import { LOCAL_LANG_KEY_CLINIC } from '@/constants/cache-key'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const LOGIN_STORE_KEY = 'login-store'
// 组织是切换的，诊所要从登录里面取当前的
export const defaultClinicCode = ref<string>(
  JSON.parse(localStorage.getItem(LOGIN_STORE_KEY) || '{}')?.defaultClinicCode || '',
)

export const setDefaultClinicCode = (value: string) => {
  console.log('setDefaultClinicCode == ', value)
  defaultClinicCode.value = value
  // 同步写入 localStorage，防止 persist 插件 hydration 时覆盖
  const stored = JSON.parse(localStorage.getItem(LOGIN_STORE_KEY) || '{}')
  console.log('stored == ', stored)
  stored.defaultClinicCode = value
  localStorage.setItem(LOGIN_STORE_KEY, JSON.stringify(stored))
}

export const useLoginStore = defineStore(
  'login',
  () => {
    // const token = ref<string>('')
    // const username = ref<string>('')
    // const roles = ref<string[]>([])
    const currentLang = ref<string>(localStorage.getItem(LOCAL_LANG_KEY_CLINIC) || 'zh-HK')

    const setCurrentLang = (value: string) => {
      currentLang.value = value
      localStorage.setItem(LOCAL_LANG_KEY_CLINIC, value)
    }

    return {
      currentLang,
      setCurrentLang,
      defaultClinicCode,
      setDefaultClinicCode,
    }
  },
  {
    persist: {
      key: LOGIN_STORE_KEY,
      storage: localStorage,
      pick: ['defaultClinicCode'],
    },
  },
)
